import { AuthFormContent, AuthMode } from "./types";

export const AUTH_FORM_CONTENT: Record<
  AuthMode.LOGIN | AuthMode.SIGN_UP,
  Record<AuthFormContent, string>
> = {
  [AuthMode.LOGIN]: {
    [AuthFormContent.SUBMIT_BUTTON]: "Log In",
    [AuthFormContent.SWITCH_AUTH_MODE_INSTRUCTIONS]: "New to Clipboard?",
    [AuthFormContent.SWITCH_AUTH_MODE_CTA]: "Create an account",
    [AuthFormContent.SUPPORT_EMAIL_SUBJECT]: "Log In",
  },
  [AuthMode.SIGN_UP]: {
    [AuthFormContent.SUBMIT_BUTTON]: "Sign Up",
    [AuthFormContent.SWITCH_AUTH_MODE_INSTRUCTIONS]: "Already have an account?",
    [AuthFormContent.SWITCH_AUTH_MODE_CTA]: "Log in instead",
    [AuthFormContent.SUPPORT_EMAIL_SUBJECT]: "Sign Up",
  },
};
